// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__SvL2d","marginTop":"Footer_marginTop__vYVU+","removeMargT":"Footer_removeMargT__I8VJU"};